import { makeStyles, Theme } from '@material-ui/core/styles';
import Image from '../../assets/Patterns.png';

export const useStyles = makeStyles((theme: Theme) => ({
  logo: {
    marginLeft: '40px',
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    height: '106px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #E0E0E0',
  },
  footer: {
    position: 'absolute',
    bottom: '32px',
    right: '50%',
    transform: 'translate(50%,-50%)',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '26px',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.54)',
    '@media (max-height: 768px)': {
      position: 'relative',
      bottom: 0,
      right: 0,
      transform: 'none',
      margin: '15px 0',
    },
  },
  container: {
    height: '100vh',
    background: `url(${Image}), linear-gradient(180deg, #FFFFFF -30.28%, #E2E6F7 161.33%)`,
    backgroundPosition: 'bottom, left top',
    backgroundRepeat: 'repeat-x, repeat',
    backgroundSize: 'contain, cover',
  },
}));
